/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_PauseInputs */



/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Timer_PauseInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_pause = /** @type {((inputs?: Timer_PauseInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_PauseInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pause")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pausa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pausa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pausa")
	return /** @type {LocalizedString} */ ("Pause")
});